<template>
    <div class="editorContainer"></div>
</template>

<script>
import wangEditor from 'wangeditor'
import setupEditor from '../utils/setupEditor';

export default {
    model: {
        prop: 'value',
        event: 'change-value',
    },
    props: {
        value: String,
    },
    mounted() {
        const editor = new wangEditor(this.$el)

        // 配置 onchange 回调函数，将数据同步到 vue 中
        editor.config.onchange = (newHtml) => {
            this.$emit('change-value', newHtml);
        }

        setupEditor(editor);

        // 创建编辑器
        editor.create();
        editor.txt.html(this.value);
        this.editor = editor;
    },
    methods: {
        setValue(value) {
            this.editor.txt.html(value);
        }
    },
    beforeDestroy() {
        this.editor.destroy()
        this.editor = null
    }
}
</script>

<style>

</style>